/**
 * Used to regulate the MessageBar's background color and default icon
 */
export var MessageBarSeverity;
(function (MessageBarSeverity) {
    MessageBarSeverity["Info"] = "Info";
    MessageBarSeverity["Warning"] = "Warning";
    MessageBarSeverity["Error"] = "Error";
    MessageBarSeverity["Success"] = "Success";
})(MessageBarSeverity || (MessageBarSeverity = {}));
